import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import { MagicWand } from "phosphor-react";
import * as React from "react";
import { MAKE_IT_WORK_BLUE } from "../../../components/make-it-work/MakeItWork";
// styles
import { colors, greys } from "../../../styles/color.styles";

// util
import { opacity } from "../../../util/color.util";

export interface MaskProps {
  text?: string;
  variant?:
    | "outside-meeting-hours"
    | "outside-meeting-hours-busy-overlay"
    | "busy"
    | "hold"
    | "selected-slot"
    | "suggested-move";
  className?: string;
  style?: React.HTMLAttributes<HTMLDivElement>["style"];
}

const useStyles = makeStyles({
  container: {
    "&.outside-meeting-hours": {
      background: `repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 10px,
        ${greys.palePaleGrey} 10px,
        ${greys.palePaleGrey} 20px
      )`,
    },
    "&.outside-meeting-hours-busy-overlay": {
      background: opacity(greys.dark, 0.1),
    },
    "&.busy": {
      background: greys.cloudyBlue,
    },
    "&.hold": {
      background: `linear-gradient(180deg, ${opacity(colors.blueSky.lightest, 0.12)} 0%, ${opacity(
        colors.blueSky.lightest,
        0.04,
      )} 100%)`,
      border: `1px solid ${colors.blueSky.lightest}`,
      borderRadius: 3,
      zIndex: 2,
    },
    "&.selected-slot": {
      background: opacity("#455556", 0.8),
      borderRadius: 3,
      border: `2px solid ${greys.darkestGrey}`,
      color: "white",
      fontSize: 12,
      display: "flex",
      alignItems: "center",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
    "&.suggested-move": {
      background: opacity("#455556", 0.8),
      borderRadius: "3px !important",
      border: `2px solid ${MAKE_IT_WORK_BLUE}`,
      backgroundColor: colors.green.lightest,
      color: greys.darkestGrey,
      fontSize: 12,
      display: "flex",
      alignItems: "center",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
});

export const Mask = ({ variant = "outside-meeting-hours", className, style, text }: MaskProps) => {
  const classes = useStyles();

  const isSuggestedMove = variant == "suggested-move";

  return (
    <div
      style={style}
      className={classNames(classes.container, variant, className, {
        "cw-pr-2": isSuggestedMove,
      })}
    >
      {text}
      {isSuggestedMove && (
        <div className="cw-flex cw-items-center cw-gap-1 cw-mb-1 cw-font-bold cw-absolute cw-right-0 cw-top-1 cw-bg-[#d3f7d9]">
          <MagicWand color="#4459dd" weight="fill" size="14px" />
        </div>
      )}
    </div>
  );
};
